const initialState = {};

const Login_REDUCER = (state = initialState, action) => {
    switch (action.type) {
        case "Login":
            return action.payload || state;
            
        case "Logout":
            return initialState;

        default:
            return state;
    }
}

export default Login_REDUCER;